var map = {
	"./book-icon.svg": 1672,
	"./cancel.svg": 8539,
	"./download.svg": 7137,
	"./icon-geren.svg": 646,
	"./info01.svg": 2680,
	"./new.svg": 5861,
	"./wxLogin.svg": 2815,
	"./上传图片.svg": 5262,
	"./书籍.svg": 5878,
	"./云书展.svg": 5625,
	"./五星.svg": 3886,
	"./人数.svg": 879,
	"./全屏.svg": 498,
	"./取消2.svg": 5379,
	"./工作台.svg": 9446,
	"./已登记货源信息.svg": 8033,
	"./序号.svg": 6919,
	"./开发运营.svg": 8657,
	"./微信.svg": 8618,
	"./手机.svg": 1846,
	"./播放.svg": 3568,
	"./放大镜.svg": 3448,
	"./服务人员.svg": 3173,
	"./样书管理.svg": 5959,
	"./样书系统.svg": 8684,
	"./样章试读-电子书.svg": 400,
	"./注意.svg": 6114,
	"./用户--未登录头像.svg": 4861,
	"./用户管理.svg": 1211,
	"./眼睛_隐藏_o.svg": 9736,
	"./箭头.svg": 762,
	"./营销管理.svg": 9383,
	"./营销系统.svg": 5628,
	"./购物车.svg": 1747,
	"./运营开发.svg": 3505,
	"./选择.svg": 7747,
	"./院校管理.svg": 1951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;